import "babel-polyfill";

//blog-modules
import {binder, fwa} from "./libs/binder";
import {detectDevicesAndBrowser} from "./modules/module";
//import {showAnnouncamentBar} from "./modules/announcement-bar";
//import {showAnnouncamentBarNew} from "./modules/announcement-bar-new";
//import {showAnnouncamentBarg} from "./modules/announcement-bar-g";
import {showCookieBar} from "./modules/cookie-bar";
import {navDropdown} from "./modules/nav-dropdown";
import {initStickyHeader} from "./modules/sticky-header";
import {filterScroll} from "./modules/blog-scroll";
import {blogImageWrap} from "./modules/blog-image-wrap";
import {searchFix} from "./modules/algolia-scroll-fix";
import {initAlgolia} from "./modules/init-algolia";
import {showSearchbar} from "./modules/show-searchbar";
//blog-modules

import "./libs/jcf";
import "slick-carousel";
//import "./libs/slider";

import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import {initJCFSelect} from "./modules/jcf-init";
import {toggleLanguage} from "./modules/toggle-language";
import {learnIndexSearch} from "./modules/learn-index-search";
import {asideFilterAccordion} from "./modules/aside-filter-accordion";
import {asideLinksAccordion} from "./modules/aside-links-accordion";
import {popups} from "./modules/popups";
import {popupsStoryOne} from "./modules/popups-story-one";
import {popupsStoryTwo} from "./modules/popups-story-two";
import {popupsStoryThree} from "./modules/popups-story-three";
import {popupsStoryFour} from "./modules/popups-story-four";
import {popupsStoryFive} from "./modules/popups-story-five";
import {popupsStorySix} from "./modules/popups-story-six";
import {popupsStorySeven} from "./modules/popups-story-seven";
import {popupsStoryEight} from "./modules/popups-story-eight";
import {popupsStoryNine} from "./modules/popups-story-nine";
import {popupsStoryTen} from "./modules/popups-story-ten";
import {popupsStoryEleven} from "./modules/popups-story-eleven";
import {popupsStoryTwelve} from "./modules/popups-story-twelve";
import {popupsStoryThirteen} from "./modules/popups-story-thirteen";
import {popupsStoryFourteen} from "./modules/popups-story-fourteen";
import {popupsStoryFifteen} from "./modules/popups-story-fifteen";
import {popupsStorySixteen} from "./modules/popups-story-sixteen";
import {popupsStorySeventeen} from "./modules/popups-story-seventeen";
import {popupsStoryEighteen} from "./modules/popups-story-eighteen";
import {popupsStoryNineteen} from "./modules/popups-story-nineteen";
import {popupsStoryTwenty} from "./modules/popups-story-twenty";
import {popupsStoryTwentyone} from "./modules/popups-story-twentyone";
import {popupsStoryTwentytwo} from "./modules/popups-story-twentytwo";
import {popupsStoryTwentythree} from "./modules/popups-story-twentythree";
import {popupsStoryTwentyfour} from "./modules/popups-story-twentyfour";
import {popupsStoryTwentyfive} from "./modules/popups-story-twentyfive";
import {popupsStoryTwentysix} from "./modules/popups-story-twentysix";
import {popupsStoryTwentyseven} from "./modules/popups-story-twentyseven";
import {popupsStoryTwentyeight} from "./modules/popups-story-twentyeight";
import {popupsStoryTwentynine} from "./modules/popups-story-twentynine";
import {popupsStoryThirty} from "./modules/popups-story-thirty";
import {popupsStoryThirtyone} from "./modules/popups-story-thirtyone";
import {popupsStoryThirtytwo} from "./modules/popups-story-thirtytwo";
import {popupsStoryThirtythree} from "./modules/popups-story-thirtythree";
import {popupsStoryThirtyfour} from "./modules/popups-story-thirtyfour";
import {popupsStoryThirtyfive} from "./modules/popups-story-thirtyfive";
import {popupsStoryThirtysix} from "./modules/popups-story-thirtysix";
import {popupsStoryThirtyseven} from "./modules/popups-story-thirtyseven";
import {popupsStoryThirtyeight} from "./modules/popups-story-thirtyeight";
import {popupsStoryThirtynine} from "./modules/popups-story-thirtynine";
import {popupsStoryForty} from "./modules/popups-story-forty";
import {popupsStoryFortyOne} from "./modules/popups-story-forty-one";
import {popupsStoryFortyTwo} from "./modules/popups-story-forty-two";
import {popupsStoryFortyThree} from "./modules/popups-story-forty-three";
import {popupsStoryFortyFour} from "./modules/popups-story-forty-four";
import {popupsStoryFortyFive} from "./modules/popups-story-forty-five";
import {popupsStoryFortySix} from "./modules/popups-story-forty-six";
import {popupsStoryFortySeven} from "./modules/popups-story-forty-seven";
import {scrollToCurrent} from "./modules/scroll-to-current";
import {stickyElements} from "./modules/sticky-elements";
import {stickyElementsOnline} from "./modules/sticky-elements-online";
import {stickyElementsGoldenPages} from "./modules/sticky-elements-golden-pages";
import {customParalax} from "./modules/custom-parallax";
import {moveBg} from "./modules/moving-bg";
import {defineLayout} from "./modules/link-out-layouts";
import {initCustomerLogosSlider} from "./modules/customer-logos-slider";
import {squareSlider} from "./modules/squareSlider";
import {onScrollAnimation} from "./modules/scroll-animation";
import {stickyCardsAnchors} from "./modules/sticky-cards-anchors";
import {stickyCardsScroll} from "./modules/sticky-cards-scroll";
import {postsSlider} from "./modules/posts-slider-init";
import {postsSliderSol1} from "./modules/posts-slider-sol1";
import {postsSliderSol2} from "./modules/posts-slider-sol2";
import {postsSliderSol3} from "./modules/posts-slider-sol3";
import {postsSliderSol4} from "./modules/posts-slider-sol4";
import {postsSliderStories} from "./modules/posts-slider-stories";
import {anchorLinks} from "./modules/anchor-links";
//this line here needs to be active with line below
//import {compareTablesInit} from "./modules/compare-tables";
import {faqAccordion} from "./modules/faq-accordion";
import {reviewsSlider} from "./modules/reviews-slider-init";
import {reviewsSliderSolutions} from "./modules/reviews-slider-solutions";
import {starsRating} from "./modules/stars-rating";
import {businessEditionNav} from "./modules/business-editions-navigation";
import {hostedTrialSlider} from "./modules/hosted-trial-slider";
import {reInitJcf} from "./modules/contact-form-fix";
import {footerAccordion} from "./modules/footerAccordion";
import {industry} from "./modules/industry";
import {insightsSectionSlider} from "./modules/insightsSectionSlider";
import {insightsSectionSliderbebold} from "./modules/insightsSectionSlider-bebold";
import {personMobNav} from "./modules/personMobNav";
import {caseStudySliders} from "./modules/caseStudySliders";
import {updHeroSlider} from "./modules/updHeroSlider";
import {customSvgAnimation} from "./modules/customSvgAnimation";
import {parallaxBg} from "./modules/parallaxBg";
import {raitingStars} from "./modules/raitingStars";
import {megaMenuUpd} from "./modules/megaMenuUpd";
import {numberAnimate} from "./modules/numberAnimate";
import {fullHeightPage} from "./modules/fullHeightPage";
import {reInitJcf2} from "./modules/form-web-series";
import {reInitJcf3} from "./modules/form-cta-end-of-page";
import {reInitJcf4} from "./modules/contact-form-get-started";
import { preloadVideo } from "./modules/preloadVideo";
import {initCustomerTestimonalSlider} from "./modules/customer-testimonal-slider";
//import {initCustomerKeyCapabilitiesStoriesSlider} from "./modules/key-capabilities-stories-slider";

binder({
    bounds: {
        //blog-modules
        "html": [detectDevicesAndBrowser, fullHeightPage, megaMenuUpd],
        //".announcement-bar": showAnnouncamentBar,
        //".announcement-bar": showAnnouncamentBarNew,
        //".announcement-bar": showAnnouncamentBarg,
        ".cookie-bar": showCookieBar,
        ".main-nav": navDropdown,
        ".header": initStickyHeader,
        ".blog-posts-section": filterScroll,
        ".blog-post-detail": blogImageWrap,
        "#tags-list": initAlgolia,
        ".search-panel": [showSearchbar, searchFix],
        //blog-modules

        "select": initJCFSelect,
      
        ".languages": toggleLanguage,
        "#learn-search": learnIndexSearch,
        ".aside-posts-filter .filter-block": asideFilterAccordion,
        ".overview-links": asideLinksAccordion,
        ".js-popup-link, #app": popups,
        ".js-popup-link-story-one, #appStoryOne": popupsStoryOne,
        ".js-popup-link-story-two, #appStoryTwo": popupsStoryTwo,
        ".js-popup-link-story-three, #appStoryThree": popupsStoryThree,
        ".js-popup-link-story-four, #appStoryFour": popupsStoryFour,
        ".js-popup-link-story-five, #appStoryFive": popupsStoryFive,
         ".js-popup-link-story-six, #appStorySix": popupsStorySix,
        ".js-popup-link-story-seven, #appStorySeven": popupsStorySeven,
        ".js-popup-link-story-eight, #appStoryEight": popupsStoryEight,
        ".js-popup-link-story-nine, #appStoryNine": popupsStoryNine,
        ".js-popup-link-story-ten, #appStoryTen": popupsStoryTen,
        ".js-popup-link-story-eleven, #appStoryEleven": popupsStoryEleven,
         ".js-popup-link-story-twelve, #appStoryTwelve": popupsStoryTwelve,
         ".js-popup-link-story-thirteen, #appStoryThirteen": popupsStoryThirteen,
        ".js-popup-link-story-fourteen, #appStoryFourteen": popupsStoryFourteen,
        ".js-popup-link-story-fifteen, #appStoryFifteen": popupsStoryFifteen,
        ".js-popup-link-story-sixteen, #appStorySixteen": popupsStorySixteen,
        ".js-popup-link-story-seventeen, #appStorySeventeen": popupsStorySeventeen,
        ".js-popup-link-story-eighteen, #appStoryEighteen": popupsStoryEighteen,
        ".js-popup-link-story-nineteen, #appStoryNineteen": popupsStoryNineteen,
        ".js-popup-link-story-twenty, #appStoryTwenty": popupsStoryTwenty,
        ".js-popup-link-story-twentyone, #appStoryTwentyone": popupsStoryTwentyone,
        ".js-popup-link-story-twentytwo, #appStoryTwentytwo": popupsStoryTwentytwo,
        ".js-popup-link-story-twentythree, #appStoryTwentythree": popupsStoryTwentythree,
        ".js-popup-link-story-twentyfour, #appStoryTwentyfour": popupsStoryTwentyfour,
        ".js-popup-link-story-twentyfive, #appStoryTwentyfive": popupsStoryTwentyfive,
        ".js-popup-link-story-twentysix, #appStoryTwentysix": popupsStoryTwentysix,
        ".js-popup-link-story-twentyseven, #appStoryTwentyseven": popupsStoryTwentyseven,
        ".js-popup-link-story-twentyeight, #appStoryTwentyeight": popupsStoryTwentyeight,
        ".js-popup-link-story-twentynine, #appStoryTwentynine": popupsStoryTwentynine,
        ".js-popup-link-story-thirty, #appStoryThirty": popupsStoryThirty,
        ".js-popup-link-story-thirtyone, #appStoryThirtyone": popupsStoryThirtyone,
        ".js-popup-link-story-thirtytwo, #appStoryThirtytwo": popupsStoryThirtytwo,
        ".js-popup-link-story-thirtythree, #appStoryThirtythree": popupsStoryThirtythree,
        ".js-popup-link-story-thirtyfour, #appStoryThirtyfour": popupsStoryThirtyfour,
        ".js-popup-link-story-thirtyfive, #appStoryThirtyfive": popupsStoryThirtyfive,
        ".js-popup-link-story-thirtysix, #appStoryThirtysix": popupsStoryThirtysix,
        ".js-popup-link-story-thirtyseven, #appStoryThirtyseven": popupsStoryThirtyseven,
        ".js-popup-link-story-thirtyeight, #appStoryThirtyeight": popupsStoryThirtyeight,
        ".js-popup-link-story-thirtynine, #appStoryThirtynine": popupsStoryThirtynine,
        ".js-popup-link-story-forty, #appStoryForty": popupsStoryForty,
        ".js-popup-link-story-forty-one, #appStoryFortyOne": popupsStoryFortyOne,
        ".js-popup-link-story-forty-two, #appStoryFortyTwo": popupsStoryFortyTwo,
        ".js-popup-link-story-forty-three, #appStoryFortyThree": popupsStoryFortyThree,
        ".js-popup-link-story-forty-four, #appStoryFortyFour": popupsStoryFortyFour,
        ".js-popup-link-story-forty-five, #appStoryFortyfive": popupsStoryFortyFive,
        ".js-popup-link-story-forty-six, #appStoryFortysix": popupsStoryFortySix,
        ".js-popup-link-story-forty-seven, #appStoryFortyseven": popupsStoryFortySeven,
        ".scroll-to-current": scrollToCurrent,
        ".sticky-element": stickyElements,
        ".sticky-element-online": stickyElementsOnline,
        ".sticky-element-golden-pages": stickyElementsGoldenPages,
        ".has-parallax": customParalax,
        ".moving-bg": moveBg,
        ".posts-listing.link-out": defineLayout,
        ".customer-logos .slider": initCustomerLogosSlider,
        ".square-slider": squareSlider,
        ".has-animation": onScrollAnimation,
        ".sticky-cards": [stickyCardsAnchors, stickyCardsScroll],
        ".posts-slider": postsSlider,
        ".posts-slider-sol1": postsSliderSol1,
        ".posts-slider-sol2": postsSliderSol2,
        ".posts-slider-sol3": postsSliderSol3,
        ".posts-slider-sol4": postsSliderSol4,
        ".posts-slider-stories": postsSliderStories,
        ".anchor-link": anchorLinks,
        //this line here needs to be active with the @import above 
        //".table-wrapper .compare-table": compareTablesInit,
        ".questions-accordion": faqAccordion,
        ".reviews-slider": reviewsSlider,
        ".reviews-slider-solutions": reviewsSliderSolutions,
        ".rating": starsRating,
        ".smart-applications .navigation": businessEditionNav,
        ".trial-slider": hostedTrialSlider,
        ".footer": footerAccordion,
        ".industry-section": industry,
        ".insights-section": insightsSectionSlider,
        ".insights-section-bebold": insightsSectionSliderbebold,
        ".persons-section": personMobNav,
        ".case-study-section": caseStudySliders,
        ".updated-hero-section": updHeroSlider,
        "[data-src-path]": customSvgAnimation,
        ".parallax-bg": parallaxBg,
        ".forrester-section": [raitingStars, numberAnimate],
        ".form-section-web-series .form-holder-web-series": reInitJcf2,
        ".list-section": preloadVideo,
        ".customer-testimonal .slider": initCustomerTestimonalSlider,
        //".key-capabilities-stories-slider .slider": initCustomerKeyCapabilitiesStoriesSlider,
        ".form-section .form-holder": reInitJcf,
        ".form-section-end-cta .form-holder": reInitJcf3,
        ".form-section-get-started .form-holder-no-shadow": reInitJcf4
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js